
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 64 64"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14 57a1 1 0 01-.39-.08A1 1 0 0113 56v-9H9a5 5 0 01-5-5V18a5 5 0 015-5h40a5 5 0 015 5v24a5 5 0 01-5 5H24.84l-10.15 9.72A1 1 0 0114 57zM9 15a3 3 0 00-3 3v24a3 3 0 003 3h5a1 1 0 011 1v7.66l8.75-8.38a1 1 0 01.69-.28H49a3 3 0 003-3V18a3 3 0 00-3-3zm51 21V12a5 5 0 00-5-5H15a5 5 0 00-5 5h2a3 3 0 013-3h40a3 3 0 013 3v24a3 3 0 01-3 3v2a5 5 0 005-5zm-30-4.08A6 6 0 1023 26h2a4 4 0 114 4 1 1 0 00-1 1v5h2zM30 38h-2v2h2z"}})])
          )
        }
      }
    